const PRODUCTION_PROJECT_ID = 'portal-sisfol';
const APPROVED_E2E_PROJECT_ID = 'sisdp-hml-693463-20260815';
const REQUIRED_FIELDS = [
  'apiKey',
  'authDomain',
  'projectId',
  'storageBucket',
  'messagingSenderId',
  'appId',
  'databaseURL',
];

const assertCompleteConfig = (config, label) => {
  if (!config || typeof config !== 'object' || Array.isArray(config)) {
    throw new Error(`${label}: configuração Firebase inválida.`);
  }

  const missingFields = REQUIRED_FIELDS.filter((field) => !String(config[field] || '').trim());
  if (missingFields.length > 0) {
    throw new Error(`${label}: configuração Firebase incompleta (${missingFields.join(', ')}).`);
  }
};

const parseE2EConfig = (serializedE2EConfig) => {
  if (!serializedE2EConfig) {
    throw new Error('E2E: REACT_APP_E2E_FIREBASE_CONFIG é obrigatória.');
  }

  try {
    return JSON.parse(serializedE2EConfig);
  } catch (_error) {
    throw new Error('E2E: REACT_APP_E2E_FIREBASE_CONFIG contém JSON inválido.');
  }
};

export const resolveFirebaseEnvironment = ({
  environment,
  serializedE2EConfig,
  allowedE2EProjectId,
  productionConfig,
} = {}) => {
  const normalizedEnvironment = String(environment || 'PRODUCTION').trim().toUpperCase();

  if (normalizedEnvironment === 'PRODUCTION') {
    if (serializedE2EConfig || allowedE2EProjectId) {
      throw new Error('PRODUCTION: variáveis exclusivas de E2E não são permitidas.');
    }
    assertCompleteConfig(productionConfig, 'PRODUCTION');
    if (productionConfig.projectId !== PRODUCTION_PROJECT_ID) {
      throw new Error('PRODUCTION: projectId produtivo inesperado.');
    }
    return { environment: 'PRODUCTION', isE2E: false, firebaseConfig: productionConfig };
  }

  if (normalizedEnvironment !== 'E2E') {
    throw new Error(`Ambiente Firebase desconhecido: ${normalizedEnvironment}.`);
  }

  const firebaseConfig = parseE2EConfig(serializedE2EConfig);
  assertCompleteConfig(firebaseConfig, 'E2E');

  const expectedProjectId = String(allowedE2EProjectId || '').trim();
  if (!expectedProjectId || expectedProjectId === PRODUCTION_PROJECT_ID) {
    throw new Error('E2E: projectId permitido é obrigatório e não pode ser o de produção.');
  }
  if (expectedProjectId !== APPROVED_E2E_PROJECT_ID) {
    throw new Error('E2E: projectId não pertence ao laboratório aprovado.');
  }
  if (firebaseConfig.projectId !== expectedProjectId) {
    throw new Error('E2E: projectId da configuração não corresponde à allowlist.');
  }

  const e2eReferences = [
    firebaseConfig.projectId,
    firebaseConfig.authDomain,
    firebaseConfig.storageBucket,
    firebaseConfig.databaseURL,
  ];
  if (e2eReferences.some((value) => String(value).includes(PRODUCTION_PROJECT_ID))) {
    throw new Error('E2E: referência ao projeto de produção bloqueada.');
  }

  return { environment: 'E2E', isE2E: true, firebaseConfig };
};

export const getFirebaseRuntimeConfig = (productionConfig) => resolveFirebaseEnvironment({
  environment: process.env.REACT_APP_SISDP_ENVIRONMENT,
  serializedE2EConfig: process.env.REACT_APP_E2E_FIREBASE_CONFIG,
  allowedE2EProjectId: process.env.REACT_APP_E2E_PROJECT_ID,
  productionConfig,
});

export const buildFirebaseServiceWorkerUrl = (workerUrl, { environment, firebaseConfig }) => {
  assertCompleteConfig(firebaseConfig, 'SERVICE_WORKER');
  const query = new URLSearchParams({
    sisdpEnvironment: environment,
    firebaseConfig: JSON.stringify(firebaseConfig),
  });
  return `${workerUrl}?${query.toString()}`;
};
